import config from '../config';

export default class MessageService {

  constructor() {

    this._baseUrl = config.LEGACY_API_BASE_URL;
  }

  /**
  * @param {Object} options
  * @param {string} options.name
  * @param {string} options.phoneOrEmail
  * @param {string} [options.instrument]
  * @param {string} [options.studentAge]
  * @param {string} [options.extraInfo]
  */
  async sendLessonInfoMessage(options) {

    const response = await fetch(`${this._baseUrl}/api/v1/lessoninfo`, {
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(options)
    });
    if (!response.ok) {
      this._handleError(response);
    }
  }

  async _handleError(response) {

    const body = await response.text();
    throw new Error(`An error occurred while fetching the product listings. Status: ${response.statusCode}, body: ${body}`);
  }
}



// WEBPACK FOOTER //
// ./src/services/LessonService.js